import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { PermissionResourceService } from "../../core/services/permission-resource.service";


@Injectable({
	providedIn: 'root'
})
export class PermissionsCanAccessRouter implements CanActivate {

	constructor(private permissionResourceService: PermissionResourceService,
				private router: Router) {
	}

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
		const isAllowed = await this.permissionResourceService.canActivate(route.data.permissions ? route.data.permissions[0] : null);

		if (!isAllowed) {
			this.router.navigate(["error/403"]);
		}

		return isAllowed;
	}

}
